module.exports = __webpack_public_path__ + "img/signup-logo.81708b61.png";